module.exports = __webpack_public_path__ + "static/img/12BJ.d3092eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/12BJ.png
// module id = YfS3
// module chunks = 2